import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '关于我们', path: '/about' },
  ],
  categories: categories.slice(0, 6).map((c) => ({
    label: c.name,
    path: `/category/${c.slug}`,
  })),
  about: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '加入我们', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-global-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                亚洲专区
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              汇聚亚洲各地精选优质内容，涵盖文化、娱乐、资讯、产品与服务。一站式探索亚洲无限可能。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200" aria-label="小红书">
                <i className="ri-red-packet-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800/80 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 亚洲专区 版权所有
          </p>
          <p className="text-sm text-background-600">
            精选亚洲内容一站汇聚 · 探索亚洲无限可能
          </p>
        </div>
      </div>
    </footer>
  );
}